import { TextAreaField as TextAreaFieldType, FieldError } from "graphql";
import useGravityForm, {
  ACTION_TYPES,
  FieldValue,
  StringFieldValue,
} from "utilities/useGravityForm";

interface Props {
  field: TextAreaFieldType;
  fieldErrors: FieldError[];
  formId: string;
}

const DEFAULT_VALUE = "";

export default function TextAreaField({ field, fieldErrors, formId }: Props) {
  const {
    databaseId: id,
    type,
    label,
    description,
    cssClass,
    isRequired,
  } = field;
  const htmlId = `field_${formId}_${id}`;
  const { state, dispatch } = useGravityForm();
  const fieldValue = state.find(
    (fieldValue: FieldValue) => fieldValue.id === id,
  ) as StringFieldValue | undefined;
  const value = fieldValue?.value || DEFAULT_VALUE;

  return (
    <div
      className={`gfield flex flex-col font-sans gfield-${type} ${cssClass}`.trim()}
    >
      <label
        className={`sr-only mb-2 text-left text-sm font-bold text-gray-700`}
        htmlFor={htmlId}
      >
        {`${label} ${isRequired ? "(required)" : ""}`}
      </label>
      <textarea
        name={String(id)}
        id={htmlId}
        required={Boolean(isRequired)}
        value={value}
        className={`min-h-[220px] w-full border-b-2 border-primary bg-transparent px-2 py-2 font-sans`}
        placeholder={
          (isRequired
            ? `${label}*\n${description ?? ``}`
            : `${label}\n${description ?? ``}`) ?? ``
        }
        onChange={(event) => {
          dispatch({
            type: ACTION_TYPES.updateTextAreaFieldValue,
            fieldValue: {
              id,
              value: event.target.value,
            },
          });
        }}
      />
      {/* {description ? <p className="field-description">{description}</p> : null} */}
      {fieldErrors?.length
        ? fieldErrors.map((fieldError) => (
            <p key={fieldError.id} className="error-message">
              {fieldError.message}
            </p>
          ))
        : null}
    </div>
  );
}
